/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ccsl_Export_Metadata_AuthorInputs */



/**
* | output |
* | --- |
* | "Author: {name}" |
*
* @param {Ccsl_Export_Metadata_AuthorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_metadata_author = /** @type {((inputs: Ccsl_Export_Metadata_AuthorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Metadata_AuthorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Auteur : ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Autor: ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Autore: ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Автор: ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Autor: ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`作者：${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`著者: ${i?.name}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लेखक: ${i?.name}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Autor: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Author: ${i?.name}`)
});